module.exports = __webpack_public_path__ + "img/sld_annunciator_t1_red.caa3b720.svg";